import { ENTITY_NAME_IN_URI as ENTITY_NAME_IN_URI_V2 } from "@/api/config/api2.0";
import { update as updateV2 } from "@/api/getApi2.0";

export const updateOrderLineForCampaign = (campaignId, body, axios) =>
  updateV2(
    {
      path: ENTITY_NAME_IN_URI_V2.CAMPAIGNS.ORDERS_LINES.path,
      ressources: [
        {
          name: campaignId
        },
        {
          name: ENTITY_NAME_IN_URI_V2.CAMPAIGNS.ORDERS_LINES.name
        }
      ]
    },
    body,
    axios
  );
